import { useQuery } from '@tanstack/react-query';

import { SimpleConfirmPopup } from './components/SimpleConfirmPopup';
import { ConfirmedStatusChangesRequiredModal } from './components/ConfirmedStatusChangesRequiredModal';
import { useOfferValidation } from './hooks/useOfferValidation';
import { translate } from '../../../common/helpers/translate.helper';
import { useToasts } from '../../../cdl/Toast/useToasts';
import { queries } from '../../../common/api/queryKeys/queries';
import { ValidationResponseCode } from '../../../../types/ValidationResponseCode';

export const ConfirmOrderPopup = ({ onConfirm, onDismiss, isOpen, isSubmitting, offer }) => {
    const { addToast, addErrorToast } = useToasts();

    const offerValidationQuery = useOfferValidation(offer, true);

    const needsCurrentOffer = offerValidationQuery.data?.code === ValidationResponseCode.VALIDATION_FAILED;
    const currentOfferQuery = useQuery({
        ...queries.offers.detail(offer.id),
        enabled: needsCurrentOffer,
    });

    const onSubmit = async () => {
        try {
            await onConfirm();
            addToast(translate('alert.state.CONFIRMED.title'));
        } catch {
            addErrorToast(translate('global.genericToastError'));
        }
    };

    if (offerValidationQuery.isLoading || currentOfferQuery.isFetching) {
        return null;
    }

    if (offerValidationQuery.data?.code === ValidationResponseCode.VALIDATION_FAILED) {
        return <ConfirmedStatusChangesRequiredModal isOpen={isOpen} onDismiss={onDismiss} offer={offer} />;
    }

    return (
        <SimpleConfirmPopup
            isOpen={isOpen}
            onSubmit={onSubmit}
            onDismiss={onDismiss}
            headline={translate('alert.confirmorder.title')}
            description={translate('alert.confirmorder.message')}
            buttonText={translate('alert.confirmorder.btnok')}
            isSubmitting={isSubmitting}
        />
    );
};
